import { io } from "socket.io-client";

let socket = null;
let currentUserId = null;

export const initSocket = (userId, setUserStatusesCallback) => {
  if (!userId) {
    console.warn("No userId provided for socket initialization");
    return null;
  }

  if (socket && socket.connected && currentUserId === userId) {
    return socket;
  }

  if (socket && socket.connected && currentUserId !== userId) {
    socket.disconnect();
    socket = null;
  }

  currentUserId = userId;

  socket = io(process.env.REACT_APP_SERVER_URL || "", {
    withCredentials: true,
    transports: ["websocket"],
    auth: {
      token: localStorage.getItem("firebase_token"),
    },
  });

  socket.on("connect", () => {
    socket.emit("register", userId);
  });

  socket.on("registerSuccess", (data) => {
    if (setUserStatusesCallback) {
      setUserStatusesCallback((prev) => ({
        ...prev,
        [data.userId]: data.status,
      }));
    }
  });

  socket.on("onlineUsers", ({ users }) => {
    if (setUserStatusesCallback) {
      setUserStatusesCallback((prev) => {
        const updated = { ...prev };
        users.forEach(({ userId, status }) => {
          updated[userId] = status;
        });
        return updated;
      });
    }
  });

  socket.on("userStatusUpdate", ({ userId, status }) => {
    if (setUserStatusesCallback) {
      setUserStatusesCallback((prev) => {
        if (status === "offline" && prev[userId] === "online") {
          return prev;
        }

        const updated = {
          ...prev,
          [userId]: status,
        };
        return updated;
      });
    }
  });

  socket.on("connect_error", (error) => {
    console.error("WebSocket error:", error.message);
  });

  socket.on("disconnect", () => {
    if (setUserStatusesCallback) {
      setUserStatusesCallback((prev) => ({
        ...prev,
        [userId]: "offline",
      }));
    }
  });

  return socket;
};

export const getSocket = () => socket;
